import Dropdown from "../dropdown/Dropdown";
import { useHistoryManager } from "../history/useHistoryManager";
import {
  getAccessPoint,
  getAccessPointId,
  getAccessPoints,
  getOrganisation,
  setAccessPoint,
  setAccessPointId,
  setOrganisation,
} from "../slice/accessOrg-slice";
import { useAppDispatch, useAppSelector } from "../slice/hooks";
import { getBasePath, getStorePath, setStorePath } from "../slice/path-slice";

function Locations({
  locations = [],
  accessPointId,
  handleLocationChange,
  className = null,
}) {
  const dispatch = useAppDispatch();

  const storePath = useAppSelector(getStorePath);
  const basePath = useAppSelector(getBasePath);
  const { navigateTo } = useHistoryManager(storePath);

  const organisation = useAppSelector(getOrganisation);

  const accessPoint = useAppSelector(getAccessPoint);

  if (locations.length <= 1) return null;

  return (
    <Dropdown
      className={className}
      options={locations}
      value={accessPointId}
      getOptionValue={(loc) => loc.accessPointId}
      getOptionLabel={(loc) => loc.name}
      onSelect={(option) => {
        // Slugify: replace spaces with hyphens, lowercase, strip non-url chars
        const newLocation = option.name
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^a-zA-Z0-9-_]/g, "") // optional sanitization
          .toLowerCase();

        // Build destination safely without double slashes
        const destination = basePath.replace(/\/+$/, "") + "/" + newLocation;

        console.log(option.accessPointId);

        navigateTo(destination, {
          urlData: {
            organisation: organisation,
            accessPoint: option.accessPoint,
            accessPoints: locations,
            accessPointId: option.accessPointId,
          },
          replace: true,
          onNavigate: (navigate) => {
            if (navigate) {
              dispatch(setAccessPointId(option.accessPointId));
              dispatch(setAccessPoint(option.accessPoint));
              handleLocationChange({ target: { value: option.accessPointId } });
              dispatch(setStorePath(destination));
            }
          },
        });
      }}
    />
  );
}

export default Locations;
